import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ShipConfig } from '../config/ship.config';

export function forbiddenZipCodesValidator(countryCode: string, forbiddenZipCodes: string[] = []): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value || ShipConfig.forbiddenZipCodes.enabled === false) {
            return null; // Don't validate if the control is empty
        }

        const countryData = ShipConfig.forbiddenZipCodes.data.find(x => x.countryCode === countryCode && x.enabled);
        if (!countryCode || !countryData) {
            return null;
        }

        if (!forbiddenZipCodes?.length) {
            forbiddenZipCodes = countryData.zipCodes;
        }

        const isForbidden = forbiddenZipCodes.includes(control.value);
        return isForbidden ? { forbiddenZipCode: { value: control.value } } : null;
    };
}
